import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { initializeAuthWithValidation } from '../../store/slices/authSlice';

const AuthProvider = ({ children }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    // Initialize authentication state from localStorage and validate token
    dispatch(initializeAuthWithValidation());
  }, [dispatch]);

  return children;
};

export default AuthProvider;
